<div class="page-shell page-shell--canvas">

  <form [formGroup]="form" (ngSubmit)="save()" class="dc-wrapper">
    <div class="dc-header">
      <div class="dc-header__start">
        <mat-form-field appearance="outline" class="dc-name-field">
          <mat-label>{{ "meetBackground.name" | translate }}</mat-label>
          <input matInput formControlName="name" [errorStateMatcher]="errorStateMatcher" />
          @if (nameInvalid) {
            <mat-error>{{ "meetBackground.nameRequired" | translate }}</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="dc-header__actions">
        <button mat-stroked-button type="button" (click)="back()">
          {{ "cancel" | translate }}
        </button>
        <button
          mat-raised-button
          type="button"
          color="primary"
          (click)="save()"
          [disabled]="saving || loading || !pageReady"
        >
          @if (saving) {
            <mat-spinner diameter="20" class="dc-btn-spinner"></mat-spinner>
          } @else {
            <mat-icon class="dc-btn-icon">save</mat-icon>
          }
          {{ saving ? ("saving" | translate) : ("save" | translate) }}
        </button>
      </div>
    </div>
    <div class="dc-editor-grid">
      <div class="dc-section dc-preview-panel dc-preview-panel--editor">
        <div class="dc-section__content dc-preview-panel__body">
          <h3 class="dc-preview-panel__title">
            {{ "meetBackground.previewTitle" | translate }}
          </h3>
          <div class="dc-employee-picker-wrap dc-editor-preview-employee-picker">
            <app-digital-card-employee-picker
              [value]="previewEmployee"
              [templateContextId]="pickerTemplateContextId"
              (valueChange)="onPreviewEmployeeChange($event)"
              (initialSelectionResolved)="onEmployeePickerInitialResolved()"
            ></app-digital-card-employee-picker>
          </div>
          <div class="dc-preview-panel__stage">
            <app-meet-background-preview
              [layoutVariant]="previewBindings.layoutVariant"
              [barWidth]="previewBindings.barWidth"
              [corner]="previewBindings.corner"
              [logoCorner]="previewBindings.logoCorner"
              [showQrCaption]="previewBindings.showQrCaption"
              [qrCaption]="previewBindings.qrCaption"
              [showEmployeeName]="previewBindings.showEmployeeName"
              [previewEmployeeName]="previewBindings.previewEmployeeName"
              [showJobTitle]="previewBindings.showJobTitle"
              [previewJobTitle]="previewBindings.previewJobTitle"
              [showLogo]="previewBindings.showLogo"
              [logoUrl]="previewBindings.logoUrl"
              [qrData]="previewBindings.qrData"
              [opacity]="previewBindings.opacity"
              [qrBackgroundColor]="previewBindings.qrBackgroundColor"
              [logoOpacity]="previewBindings.logoOpacity"
              [logoBackgroundColor]="previewBindings.logoBackgroundColor"
              [marginPx]="previewBindings.marginPx"
              [logoMarginPx]="previewBindings.logoMarginPx"
              [sizeRatio]="previewBindings.sizeRatio"
              [logoSizeRatio]="previewBindings.logoSizeRatio"
              [fontFamily]="previewBindings.fontFamily"
              [fontCssUrl]="previewBindings.fontCssUrl"
              [companyFontFileUrl]="previewBindings.companyFontFileUrl"
              [loading]="previewBindings.loading"
              [renderedImageUrl]="previewBindings.renderedImageUrl"
            ></app-meet-background-preview>
          </div>
        </div>
      </div>

      <div class="dc-section dc-form-panel">
        <div class="dc-section__content">
          <div class="dc-form">
            <section class="dc-block">
              <header class="dc-block__head">
                <h3 class="dc-block__title">
                  {{ "meetBackground.fontSectionTitle" | translate }}
                </h3>
              </header>
              <div class="dc-block__body">
                <mat-form-field appearance="outline" class="dc-form-field-full">
                  <mat-label>{{ "meetBackground.fontLabel" | translate }}</mat-label>
                  <mat-select formControlName="fontPreset">
                    @for (font of fontPresets; track font.id) {
                      <mat-option [value]="font.id">
                        {{ font.label }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                @if (!companyBrandFontReady) {
                  <p class="dc-font-upload-hint">
                    {{ "meetBackground.companyFontMissing" | translate
                    }}<a routerLink="/settings/company">{{
                      "meetBackground.companyFontSettingsLink" | translate
                    }}</a>
                  </p>
                }
              </div>
            </section>

            <section class="dc-block">
              <header class="dc-block__head">
                <h3 class="dc-block__title">
                  {{ "meetBackground.sectionQr" | translate }}
                </h3>
                <p class="dc-block__desc">
                  {{ "meetBackground.sectionQrDesc" | translate }}
                </p>
              </header>
              <div class="dc-block__body">
                <app-searchable-select
                  class="dc-form-field-full"
                  formControlName="digitalCardProfileId"
                  [label]="'background.qrDigitalCard' | translate"
                  [options]="digitalCardTemplates"
                  [displayWith]="digitalCardTemplateLabel"
                  [valueWith]="digitalCardTemplateValue"
                  [emptyLabel]="'background.none' | translate"
                  [emptyValue]="null"
                  (valueChange)="onDigitalCardProfileChange()"
                ></app-searchable-select>
                @if (form.controls.digitalCardProfileId.value) {
                  <mat-form-field appearance="outline" class="dc-form-field-full">
                    <mat-label>{{ "meetBackground.layout" | translate }}</mat-label>
                    <mat-select formControlName="layoutVariant">
                      <mat-option value="corner">{{
                        "meetBackground.layoutCorner" | translate
                      }}</mat-option>
                      <mat-option value="bottom-bar">{{
                        "meetBackground.layoutBottomBar" | translate
                      }}</mat-option>
                      <mat-option value="full-overlay">{{
                        "meetBackground.layoutFullOverlay" | translate
                      }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  @if (isBottomBarLayout) {
                    <mat-form-field appearance="outline" class="dc-form-field-full">
                      <mat-label>{{ "meetBackground.barWidth" | translate }}</mat-label>
                      <mat-select formControlName="barWidth">
                        <mat-option value="compact">{{
                          "meetBackground.barWidthCompact" | translate
                        }}</mat-option>
                        <mat-option value="full">{{
                          "meetBackground.barWidthFull" | translate
                        }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  }
                  <mat-form-field appearance="outline" class="dc-form-field-full">
                    <mat-label>{{ "background.qrLabelText" | translate }}</mat-label>
                    <input matInput formControlName="qrCaption" maxlength="80" />
                  </mat-form-field>
                  @if (isCornerLayout) {
                    <mat-form-field appearance="outline" class="dc-form-field-full">
                      <mat-label>{{ "meetBackground.corner" | translate }}</mat-label>
                      <mat-select
                        formControlName="corner"
                        (selectionChange)="onCornerChange('corner')"
                      >
                        @if (qrCornerOptions().includes("top-left")) {
                          <mat-option value="top-left">{{
                            "meetBackground.cornerTopLeft" | translate
                          }}</mat-option>
                        }
                        @if (qrCornerOptions().includes("top-right")) {
                          <mat-option value="top-right">{{
                            "meetBackground.cornerTopRight" | translate
                          }}</mat-option>
                        }
                        @if (qrCornerOptions().includes("bottom-left")) {
                          <mat-option value="bottom-left">{{
                            "meetBackground.cornerBottomLeft" | translate
                          }}</mat-option>
                        }
                        @if (qrCornerOptions().includes("bottom-right")) {
                          <mat-option value="bottom-right">{{
                            "meetBackground.cornerBottomRight" | translate
                          }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                  <div class="dc-color-grid">
                    <app-print-color
                      [label]="'meetBackground.qrBackgroundColor' | translate"
                      [value]="form.controls.qrBackgroundColor.value"
                      [showCmyk]="false"
                      (valueChange)="onPlateColorChange('qrBackgroundColor', $event)"
                    ></app-print-color>
                  </div>
                  <div class="dc-range-field">
                    <span class="dc-range-field__label"
                      >{{ "meetBackground.opacityBackground" | translate }} ({{
                        form.get("opacity")?.value
                      }})</span
                    >
                    <input
                      type="range"
                      class="dc-range-input"
                      min="0"
                      max="1"
                      step="0.05"
                      formControlName="opacity"
                    />
                  </div>
                  <div class="dc-range-field">
                    <span class="dc-range-field__label"
                      >{{ "meetBackground.size" | translate }} ({{
                        form.get("sizeRatio")?.value
                      }})</span
                    >
                    <input
                      type="range"
                      class="dc-range-input"
                      min="0.5"
                      max="1"
                      step="0.05"
                      formControlName="sizeRatio"
                    />
                  </div>
                  <mat-form-field appearance="outline" class="dc-form-field-full">
                    <mat-label>{{ "meetBackground.margin" | translate }}</mat-label>
                    <input matInput type="number" min="0" max="80" formControlName="marginPx" />
                  </mat-form-field>
                }
              </div>
            </section>

            <section class="dc-block">
              <header class="dc-block__head">
                <h3 class="dc-block__title">
                  {{ "meetBackground.logoSection" | translate }}
                </h3>
                <p class="dc-block__desc">
                  {{ "meetBackground.sectionLogoDesc" | translate }}
                </p>
              </header>
              <div class="dc-block__body">
                <div
                  class="dc-toggle-list dc-toggle-list--stacked"
                  [class.dc-toggle-list--joins-next]="form.controls.showLogo.value"
                >
                  <div class="dc-toggle-item">
                    <mat-slide-toggle
                      color="primary"
                      formControlName="showLogo"
                      class="dc-toggle-item__control"
                    >
                      {{ "background.showLogo" | translate }}
                    </mat-slide-toggle>
                  </div>
                </div>
                @if (form.controls.showLogo.value) {
                  <div class="dc-revealed-panel">
                    <app-searchable-select
                      class="dc-form-field-full"
                      formControlName="logoUrl"
                      [label]="'digitalCards.companyLogoSelectLabel' | translate"
                      [options]="mediaImages"
                      [displayWith]="mediaLabel"
                      [valueWith]="mediaValue"
                      [imageWith]="mediaImage"
                      [emptyLabel]="'digitalCards.companyLogoOrganizationDefault' | translate"
                      [emptyValue]="''"
                      [loading]="mediaImagesLoading"
                      [disabled]="mediaImagesLoading"
                    ></app-searchable-select>
                    <mat-form-field appearance="outline" class="dc-form-field-full">
                      <mat-label>{{ "meetBackground.logoCorner" | translate }}</mat-label>
                      <mat-select
                        formControlName="logoCorner"
                        (selectionChange)="onCornerChange('logoCorner')"
                      >
                        @if (logoCornerOptions().includes("top-left")) {
                          <mat-option value="top-left">{{
                            "meetBackground.cornerTopLeft" | translate
                          }}</mat-option>
                        }
                        @if (logoCornerOptions().includes("top-right")) {
                          <mat-option value="top-right">{{
                            "meetBackground.cornerTopRight" | translate
                          }}</mat-option>
                        }
                        @if (logoCornerOptions().includes("bottom-left")) {
                          <mat-option value="bottom-left">{{
                            "meetBackground.cornerBottomLeft" | translate
                          }}</mat-option>
                        }
                        @if (logoCornerOptions().includes("bottom-right")) {
                          <mat-option value="bottom-right">{{
                            "meetBackground.cornerBottomRight" | translate
                          }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    @if (!isFullOverlayLayout) {
                      <div class="dc-color-grid">
                        <app-print-color
                          [label]="'meetBackground.logoBackgroundColor' | translate"
                          [value]="form.controls.logoBackgroundColor.value"
                          [showCmyk]="false"
                          (valueChange)="onPlateColorChange('logoBackgroundColor', $event)"
                        ></app-print-color>
                      </div>
                      <div class="dc-range-field">
                        <span class="dc-range-field__label"
                          >{{ "meetBackground.logoOpacityBackground" | translate }} ({{
                            form.get("logoOpacity")?.value
                          }})</span
                        >
                        <input
                          type="range"
                          class="dc-range-input"
                          min="0"
                          max="1"
                          step="0.05"
                          formControlName="logoOpacity"
                        />
                      </div>
                    }
                    <div class="dc-range-field">
                      <span class="dc-range-field__label"
                        >{{ "meetBackground.logoSize" | translate }} ({{
                          form.get("logoSizeRatio")?.value
                        }})</span
                      >
                      <input
                        type="range"
                        class="dc-range-input"
                        [min]="logoScaleLimits.min"
                        [max]="logoScaleLimits.max"
                        step="0.05"
                        formControlName="logoSizeRatio"
                      />
                    </div>
                    <mat-form-field appearance="outline" class="dc-form-field-full">
                      <mat-label>{{ "meetBackground.logoMargin" | translate }}</mat-label>
                      <input
                        matInput
                        type="number"
                        min="0"
                        max="80"
                        formControlName="logoMarginPx"
                      />
                    </mat-form-field>
                  </div>
                }
              </div>
            </section>

            @if (form.controls.digitalCardProfileId.value) {
              <section class="dc-block">
                <header class="dc-block__head">
                  <h3 class="dc-block__title">
                    {{ "meetBackground.infoFields" | translate }}
                  </h3>
                  <p class="dc-block__desc">
                    {{ "meetBackground.sectionInfoDesc" | translate }}
                  </p>
                </header>
                <div class="dc-block__body dc-block__body--toggles">
                  <div class="dc-toggle-list dc-toggle-list--stacked">
                    <div class="dc-toggle-item">
                      <mat-slide-toggle
                        color="primary"
                        formControlName="showEmployeeName"
                        class="dc-toggle-item__control"
                      >
                        {{ "meetBackground.showEmployeeName" | translate }}
                      </mat-slide-toggle>
                    </div>
                    <div class="dc-toggle-item">
                      <mat-slide-toggle
                        color="primary"
                        formControlName="showJobTitle"
                        class="dc-toggle-item__control"
                      >
                        {{ "meetBackground.showJobTitle" | translate }}
                      </mat-slide-toggle>
                    </div>
                  </div>
                </div>
              </section>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
@if (!pageReady) {
  <div class="dbc1-loading dbc1-loading--overlay">
    <app-loading></app-loading>
  </div>
}
</div>
